import { checkClaimsWeb } from '@eventr/common'
import {
    ColoursObj,
    MobileConfirmDialog,
    StyledPullToRefresh,
    TDialogStore,
    useDialogStore,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import { ISection } from '../../data/Data'
import i18n from '../../i18n/i18next'
import { Paths } from '../../routes'
import { bs, useBoundStore } from '../../state/bound.store'
import { filterOutCopiedItems, filterOutPendingTag } from '../../utils'
import { getIconName } from '../../v2/v2Utils'
import { NavigationView } from '../layout/NavigationView'
import { ActivitiesButton } from './components/activitiesButton'
import { AddNewItinButton } from './components/addNewItinButton'
import { PublicItinsButton } from './components/publicItinsButton'
import { SectionButton } from './components/sectionButton'
import { useGlobalRouter } from '../globalRouter/useGlobalRouter'

export const EditItinerarySectionSelection = () => {
    const { pushPath } = useGlobalRouter()
    const {
        noItineraries,
        getSectionV2FromSectionIdFromSelectedItinerary,
        sections,
        selectedItinID,
    } = useBoundStore(
        useShallow((s) => {
            return {
                noItineraries: s.noItineraries,
                sections: s.sections,
                selectedItinID: s.selectedItinID,
                getSectionV2FromSectionIdFromSelectedItinerary:
                    s.getSectionV2FromSectionIdFromSelectedItinerary,
            }
        })
    )
    const { replaceDialog, clearDialog }: TDialogStore = useDialogStore(
        useShallow((s: TDialogStore) => ({
            clearDialog: s.clearDialog,
            replaceDialog: s.replaceDialog,
        }))
    )

    const getItinTitle = () => {
        const eventInfo = bs().getEventInfoV2()
        if (eventInfo) {
            return eventInfo.data.title
        }
    }

    const onDelete = async () => {
        await bs().deleteItinerary(selectedItinID)

        clearDialog()

        pushPath('/')
    }

    const onBackPressed = () => {
        pushPath(Paths.home)
    }

    return (
        <>
            <NavigationView
                isRoot
                usePageTransition
                navigationBarTitle={i18n.t('edit-itinerary.edit-itin')}
                navigationBarSubtitle={getItinTitle()}
                backButtonAction={onBackPressed}
                navigationBarTrailing={[
                    {
                        id: 'moreButtonEditItinerary',
                        icon: 'More',
                        popoverItems: [
                            {
                                title: i18n.t(
                                    'edit-itinerary.section-selection.delete-itin'
                                ),
                                action: () => {
                                    replaceDialog({
                                        node: (
                                            <MobileConfirmDialog
                                                header={i18n.t(
                                                    'edit-itinerary.section-selection.delete-itin'
                                                )}
                                                secondaryText={getItinTitle()}
                                                text={i18n.t(
                                                    'edit-itinerary.section-selection.delete-itin-check'
                                                )}
                                                onConfirm={onDelete}
                                                onCancel={() => {
                                                    clearDialog()
                                                }}
                                                cancelText={i18n.t(
                                                    'general.cancel'
                                                )}
                                                confirmText={i18n.t(
                                                    'general.delete'
                                                )}
                                                confirmBtnStyle="destructiveBorderless"
                                            />
                                        ),
                                        backdropClosable: false,
                                    })
                                },
                                color: ColoursObj.states.error,
                                active: checkClaimsWeb(
                                    [`/${selectedItinID}`],
                                    ['deleteItinerary']
                                ),
                            },
                        ],
                    },
                ]}
            >
                <StyledPullToRefresh
                    onRefresh={async () => {}}
                    promiseFunction={async () => {
                        const promises = [bs().pullEditValues()]
                        await Promise.all(promises)
                    }}
                >
                    <Stack>
                        {!noItineraries && (
                            <>
                                {sections.map(
                                    (section: ISection, index: number) => {
                                        if (section.id === 8) {
                                            return (
                                                <ActivitiesButton key={index} />
                                            )
                                        }
                                        const sectionV2 =
                                            getSectionV2FromSectionIdFromSelectedItinerary(
                                                section.id
                                            )
                                        var sectionDataSafe = []
                                        try {
                                            sectionDataSafe = sectionV2?.data[
                                                Object.keys(sectionV2.data)[0]
                                            ]
                                                .filter(filterOutCopiedItems)
                                                .filter(filterOutPendingTag)
                                        } catch {}

                                        return (
                                            <SectionButton
                                                claimPaths={[
                                                    `/${selectedItinID}/${section.id}`,
                                                ]}
                                                claims={['editItinerary']}
                                                key={index}
                                                count={sectionDataSafe?.length}
                                                elementID={section.name}
                                                onClick={() => {
                                                    if (section.id === 1) {
                                                        pushPath(
                                                            Paths.editEventInfo
                                                        )
                                                    } else {
                                                        window.pushPath(
                                                            '/edit/Section/' +
                                                                section.id
                                                        )
                                                    }
                                                }}
                                                icon={getIconName(section.id)}
                                                text={i18n.t(
                                                    section.id === 1
                                                        ? 'sections.general-info'
                                                        : `sections.${section?.properties?.jsonName}`,
                                                    { count: 0 }
                                                )}
                                            />
                                        )
                                    }
                                )}
                            </>
                        )}
                        <SectionButton
                            claimPaths={[`/${selectedItinID}/1`]}
                            claims={['editItinerary']}
                            elementID={'teamMemberSection'}
                            onClick={() => {
                                window.pushPath('/edit/members')
                            }}
                            icon={'Users'}
                            text={i18n.t('team.members')}
                        />
                        <PublicItinsButton />
                        <AddNewItinButton />
                    </Stack>
                </StyledPullToRefresh>
            </NavigationView>
        </>
    )
}
